<div class="container mt-3">
    <div class="main">
        <h1>Nuestros productos</h1>
        <hr>
        <div class="card p-3 mb-3">
            <h4>¿Que estas buscando?</h4>
            <hr>
            <form [formGroup]="form" (ngSubmit)="applyFilter()">
                <div class="d-flex justify-content-around m-3">
                    <div class="input-group flex-nowrap input-search">
                        <b class="m-2">Nombre:</b>
                        <input type="text" class="form-control" placeholder="Remerita blanca..." formControlName="name">
                    </div>
                    <b class="m-2">Categoría:</b>
                    <select formControlName="category"  class="form-select input-search">
                        <option disabled selected>Categoria</option>
                        <option *ngFor="let cat of categories" [ngValue]="cat?.name">{{cat.name}}</option>
                    </select>
                </div>
                <div class="d-flex justify-content-start">
                    <div class="container">
                        <b>Talles:</b>
                        <span *ngFor="let t of talles" class="talle background-primary">
                            {{t}}<input class="m-1" type="checkbox" [formControlName]="t">
                        </span>
                    </div>
                    <button type="reset" *ngIf="filtered" class="mr-1 btn background-secondary" (click)="cleanFilter()">Limpiar filtro</button>
                    <button type="submit" class="btn btn-warning">Aplicar</button>
                </div>
            </form>
        </div>
        <div class="container-fluid">

            <div *ngIf="!loading" class="row g-1">
                <app-product-card class="col-6 col-md-3" *ngFor="let product of productsToShow" [product]="product">
                </app-product-card>
            </div>
            <div *ngIf="loading"  class="d-flex justify-content-center">
                <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
        </div>
    </div>
</div>